// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import internalEndpoints from '@tcp/core/src/components/features/account/common/internalEndpoints';
import { routerPush, isCanada } from '@tcp/core/src/utils';
import {
  getIsAccountBillingInternationalAddress,
  getIsCaptchaEnabledOnMyAccount,
  getMapboxSwitch,
  getNewGlobalErrorMessage,
  getIsCvvEnabledForAccount,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { cvvModuleXContent } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { fetchCvvInfoModuleX } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.actions';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import AddEditCreditCardSaga from '@tcp/core/src/components/features/account/AddEditCreditCard/container/AddEditCreditCard.saga';
import AddressBookReducer from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.reducer';
import AddressBookSaga from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.saga';
import AddEditCreditCardReducer from '@tcp/core/src/components/features/account/AddEditCreditCard/container/AddEditCreditCard.reducer';
import { getAddressList } from '../../AddressBook/container/AddressBook.actions';
import { verifyAddress } from '../../../../common/organisms/AddressVerification/container/AddressVerification.actions';

import {
  getCardType,
  getCreditCardById,
  getOnFileAddressKey,
  getAddEditCreditCardSuccess,
  getAddEditCreditCardError,
  getAddGiftCardErrorMessage,
  getshowNotification,
  getCCAddressFormValue,
} from './AddEditCreditCard.selectors';
import constants from './AddEditCreditCard.constants';
import AddEditCreditCardComponent from '../views/AddEditCreditCard.view';
import { getAddressListState } from '../../AddressBook/container/AddressBook.selectors';
import { addCreditCard, editCreditCard, resetErrorState } from './AddEditCreditCard.actions';
import { setDefaultPaymentSuccess } from '../../Payment/container/Payment.actions';
import { getCreditCardExpirationOptionMap } from '../../../../../utils';
import GlobalErrorComponentReducer from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.reducer';
import {
  hideError,
  setGlobalError,
} from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '../../../../../utils/labels/labelUtilty';
import labelsObj from '../../Payment/Payment.labels';

export class AddEditCreditCard extends React.PureComponent {
  static propTypes = {
    creditCard: PropTypes.shape({}),
    cardType: PropTypes.string,
    onFileAddressKey: PropTypes.string,
    addressList: PropTypes.shape([]),
    isPLCCEnabled: PropTypes.bool,
    addEditCreditCardSuccess: PropTypes.shape({}),
    addEditCreditCardError: PropTypes.string,
    getAddressListAction: PropTypes.func.isRequired,
    addCreditCardAction: PropTypes.func.isRequired,
    editCreditCardAction: PropTypes.func.isRequired,
    showSuccessNotification: PropTypes.func.isRequired,
    showNotification: PropTypes.bool.isRequired,
    addEditCreditCardErrorMsg: PropTypes.string,
    resetErrorNotification: PropTypes.func.isRequired,
    verifyAddressAction: PropTypes.func.isRequired,
    isRecaptchaEnabled: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    cardType: '',
    addressList: List(),
    isPLCCEnabled: true,
    onFileAddressKey: '',
    addEditCreditCardSuccess: null,
    addEditCreditCardError: null,
    creditCard: null,
    addEditCreditCardErrorMsg: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      initialValues: {},
    };
    this.creditCardExpirationOptionMap = getCreditCardExpirationOptionMap();
    this.creditCardDetail = {};
    this.paymentGCLabels =
      getLabelFromCopyOrFromTranslation('account.paymentGC', labelsObj) ||
      labelsObj.account.paymentGC;
  }

  componentDidMount() {
    const { getAddressListAction, fetchCvvContentModuleX } = this.props;
    const { referred } = getDynamicLabelValues('checkout.billing');

    const cvvContentId = referred && referred[0];
    if (cvvContentId && cvvContentId.contentId) {
      fetchCvvContentModuleX(cvvContentId.contentId);
    }
    getAddressListAction();
    this.setInitialValues();
  }

  componentDidUpdate(prevProps) {
    const {
      addEditCreditCardSuccess,
      showSuccessNotification,
      creditCard,
      addressList,
      addEditCreditCardError,
      setGlobalErrorAction,
      addEditCreditCardErrorMsg,
    } = this.props;
    const isAddressListUpdated = !prevProps.addressList && addressList;
    const errMsg =
      addEditCreditCardError?.get('errorCode') !== 'INTERNAL_SERVER_ERROR'
        ? addEditCreditCardError?.get('errorMessage')
        : addEditCreditCardErrorMsg;
    if (!prevProps.addEditCreditCardSuccess && addEditCreditCardSuccess) {
      showSuccessNotification();
      const sucMsg = renderLabel(
        this.paymentGCLabels.lbl_payment_successMsg,
        'lbl_payment_successMsg'
      );
      setGlobalErrorAction({ message: sucMsg, type: 'success' });
      this.backToPaymentClick();
    }
    if (addEditCreditCardError) {
      setGlobalErrorAction({ message: errMsg, type: 'error' });
    }
    if (isAddressListUpdated || (!prevProps.creditCard && creditCard)) {
      this.setInitialValues();
    }
  }

  componentWillUnmount() {
    const { resetErrorNotification } = this.props;
    resetErrorNotification();
  }

  setInitialValues = () => {
    const { addressList } = this.props;
    if (addressList) {
      const initialValues = this.getInitialValues();
      this.setState({
        initialValues,
      });
    }
  };

  backToPaymentClick = () => {
    routerPush(internalEndpoints.paymentPage.link, internalEndpoints.paymentPage.path);
  };

  getExpirationRequiredFlag = () => {
    const { cardType } = this.props;

    return !cardType || !constants.PLCC_CARDS.includes(cardType);
  };

  getInitialValuesForEditMode = (creditCard) => {
    if (creditCard) {
      let cardType = creditCard.ccBrand || creditCard.ccType;
      cardType = constants.ACCEPTED_CREDIT_CARDS[cardType.toUpperCase()];
      return {
        onFileAddressKey: creditCard.billingAddressId.toString(),
        cardType,
        cardNumber: creditCard.accountNo,
        expYear: creditCard.expYear.trim(),
        expMonth: creditCard.expMonth.trim(),
        address: {
          country: isCanada() ? 'CA' : 'US',
          addressLine2: '',
        },
      };
    }

    return null;
  };

  getInitialValues = () => {
    const { addressList, creditCard } = this.props;
    let onFileAddressKey = '';

    if (addressList && addressList.size > 0) {
      const defaultBillingAddress = addressList.filter((address) => address.preferred === 'true');
      onFileAddressKey =
        defaultBillingAddress.size > 0 ? defaultBillingAddress.get(0).addressId : '';
    }

    if (creditCard) {
      return this.getInitialValuesForEditMode(creditCard);
    }

    return {
      onFileAddressKey,
      address: {
        country: isCanada() ? 'CA' : 'US',
        addressLine2: '',
      },
    };
  };

  formatPayload = (payload) => {
    const { addressLine1, addressLine2, zipCode, ...otherPayload } = payload || {};
    return {
      ...otherPayload,
      ...{
        address1: addressLine1,
        address2: addressLine2,
        zip: zipCode,
      },
    };
  };

  submitCreditCardDetails = (payload) => {
    const { creditCard, addCreditCardAction, editCreditCardAction } = this.props;
    if (creditCard && creditCard.creditCardId) {
      const userData = payload;
      userData.creditCardId = creditCard.creditCardId;
      userData.isDefault = creditCard.defaultInd;
      return editCreditCardAction(userData);
    }
    return addCreditCardAction(payload);
  };

  onCreditCardFormSubmit = (data) => {
    const {
      cardType,
      verifyAddressAction,
      addressFormValues,
      isAccountBillingInternationalAddress,
    } = this.props;
    const internationalBillingAddress =
      addressFormValues?.country !== 'US' &&
      addressFormValues?.country !== 'CA' &&
      isAccountBillingInternationalAddress;

    const payload = Object.assign(data, {
      cardType,
    });

    if (payload.onFileAddressKey) {
      return this.submitCreditCardDetails(payload);
    }
    this.creditCardDetail = payload;

    if (internationalBillingAddress) {
      // If it's an international billing address, submit the credit card details directly
      return this.submitCreditCardDetails(payload);
    }
    // Otherwise, verify the address before submitting
    const formattedPayload = this.formatPayload(payload.address);
    return verifyAddressAction(formattedPayload);
  };

  submitAddressFormAction = (payloadData) => {
    if (!payloadData) {
      return this.submitCreditCardDetails(this.creditCardDetail);
    }
    const { address1, address2, zip, ...addressData } = payloadData;
    const payload = Object.assign(this.creditCardDetail, {
      address: {
        addressLine1: address1,
        addressLine2: address2,
        zipCode: zip,
        ...addressData,
      },
    });

    return this.submitCreditCardDetails(payload);
  };

  render() {
    const {
      creditCard,
      cardType,
      onFileAddressKey,
      addressList,
      isPLCCEnabled,
      addEditCreditCardError,
      addEditCreditCardErrorMsg,
      showNotification,
      isRecaptchaEnabled,
      mapboxSwitch,
      addressFormValues,
      isAccountBillingInternationalAddress,
      newGlobalErrorMessageEnabled,
      cvvCodeRichText,
      isCvvEnabledForAccount,
    } = this.props;

    if (addressList === null) {
      return null;
    }

    const isExpirationRequired = this.getExpirationRequiredFlag();
    const { initialValues } = this.state;
    return (
      <AddEditCreditCardComponent
        isEdit={!!creditCard}
        creditCard={creditCard}
        cardType={cardType}
        onFileAddressKey={onFileAddressKey}
        isPLCCEnabled={isPLCCEnabled}
        isExpirationRequired={isExpirationRequired}
        addressList={addressList}
        expMonthOptionsMap={this.creditCardExpirationOptionMap.monthsMap}
        expYearOptionsMap={this.creditCardExpirationOptionMap.yearsMap}
        initialValues={initialValues}
        backToPaymentClick={this.backToPaymentClick}
        onSubmit={this.onCreditCardFormSubmit}
        errorMessage={addEditCreditCardError}
        showNotification={showNotification}
        globalErrorMessage={addEditCreditCardErrorMsg}
        submitAddressFormAction={this.submitAddressFormAction}
        isRecaptchaEnabled={isRecaptchaEnabled}
        mapboxSwitch={mapboxSwitch}
        addressFormValues={addressFormValues}
        isAccountBillingInternationalAddress={isAccountBillingInternationalAddress}
        newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
        cvvCodeRichText={cvvCodeRichText}
        isCvvEnabledForAccount={isCvvEnabledForAccount}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    creditCard: getCreditCardById(state, ownProps),
    addressList: getAddressListState(state, ownProps),
    cardType: getCardType(state, ownProps),
    onFileAddressKey: getOnFileAddressKey(state, ownProps),
    isPLCCEnabled: true,
    addEditCreditCardSuccess: getAddEditCreditCardSuccess(state),
    addEditCreditCardError: getAddEditCreditCardError(state),
    showNotification: getshowNotification(state),
    addEditCreditCardErrorMsg: getAddGiftCardErrorMessage(state),
    isRecaptchaEnabled: getIsCaptchaEnabledOnMyAccount(state),
    mapboxSwitch: getMapboxSwitch(state),
    addressFormValues: getCCAddressFormValue(state),
    isAccountBillingInternationalAddress: getIsAccountBillingInternationalAddress(state),
    newGlobalErrorMessageEnabled: getNewGlobalErrorMessage(state),
    cvvCodeRichText: cvvModuleXContent(state),
    isCvvEnabledForAccount: getIsCvvEnabledForAccount(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAddressListAction: (payload) => {
      dispatch(getAddressList(payload));
    },
    addCreditCardAction: (payload) => {
      dispatch(addCreditCard(payload));
    },
    editCreditCardAction: (payload) => {
      dispatch(editCreditCard(payload));
    },
    showSuccessNotification: () => {
      dispatch(setDefaultPaymentSuccess());
    },
    resetErrorNotification: () => {
      dispatch(resetErrorState());
    },
    verifyAddressAction: (payload) => {
      dispatch(verifyAddress(payload));
    },
    setGlobalErrorAction: (payload) => {
      dispatch(setGlobalError(payload));
    },
    hideErrorAction: (payload) => {
      dispatch(hideError(payload));
    },
    fetchCvvContentModuleX: (payload) => {
      dispatch(fetchCvvInfoModuleX(payload));
    },
  };
};

const withReducer = withDynamicReducer([
  {
    key: 'AddEditCreditCardReducer',
    reducer: AddEditCreditCardReducer,
  },
  { key: 'GlobalErrorComponent', reducer: GlobalErrorComponentReducer },
  { key: 'AddressBookReducer', reducer: AddressBookReducer },
]);
const withSaga = withDynamicSaga([
  { key: 'addEditCreditCard', saga: AddEditCreditCardSaga },
  { key: 'addressBookSaga', saga: AddressBookSaga },
]);
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withReducer, withSaga, withConnect)(AddEditCreditCard);
